var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 21.5999C8.68691 21.5999 5.65091 19.9254 3.87891 17.1204L4.89341 16.4794C6.44441 18.9344 9.10091 20.3999 11.9999 20.3999C16.6319 20.3999 20.3999 16.6319 20.3999 11.9999C20.3999 7.3679 16.6319 3.5999 11.9999 3.5999C9.10091 3.5999 6.44391 5.0654 4.89341 7.5204L3.87891 6.8794C5.65091 4.0744 8.68691 2.3999 11.9999 2.3999C17.2934 2.3999 21.5999 6.7064 21.5999 11.9999C21.5999 17.2934 17.2934 21.5999 11.9999 21.5999Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6249 14.8685L11.3999 12.2885V7.19995H12.5999V11.7115L15.3749 13.9315L14.6249 14.8685Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 11.3999H3V12.5999H7.2V11.3999Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42444 14.2244L5.57544 13.3754L6.95144 11.9999L5.57544 10.6244L6.42444 9.77539L8.64844 11.9999L6.42444 14.2244Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIn);
export default __webpack_public_path__ + "static/media/Check-in.e80cfb01.svg";
export { ForwardRef as ReactComponent };